import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { hooks } from 'lib.front';
import { urls } from '../../config/keys';

import ListaArchivos from './ListaArchivos';
import { generarMetadata } from './helpFunc';
const { useApolloLazyQ } = hooks;
const queryRecuperar = gql`
   query ListarAdjuntos($metadata: String, $entidadAdicional: String) {
      listarAdjuntos(metadata: $metadata, entidadAdicional: $entidadAdicional) {
         codigo
         urlFile
         metadata
      }
   }
`;
const queryDescargar = `${urls.backEnd}/adjuntos`;

function ListaArchivosGql(props) {
   const { entidadAdicional, generarParametroMetadata } = props;
   const [recuperar, { data, loading, called }] = useApolloLazyQ(queryRecuperar);
   const { metadataLista } = props;
   const [metadata, setMetadata] = useState('');

   useEffect(() => {
      if (metadataLista === undefined || metadataLista === null || metadataLista.length === 0) {
         setMetadata('');
      } else {
         generarMetadata(metadataLista).then(metaGenerado => {
            setMetadata(metaGenerado);
         });
      }
   }, [metadataLista]);
   useEffect(() => {
      let variables = {};
      if (entidadAdicional !== '') {
         variables.entidadAdicional = entidadAdicional;
      }
      if (generarParametroMetadata) {
         variables.metadata = generarParametroMetadata(metadataLista);
      } else {
         if (metadata !== '') {
            variables.metadata = metadata;
         }
      }
      recuperar({ variables });
   }, [metadata, entidadAdicional]);

   function onClickArchivo(item, index) {
      const urlItem = `${queryDescargar}/${item.urlFile}`;
      const link = document.createElement('a');
      link.href = urlItem;
      link.click();
   }

   if (loading) {
      return (
         <Typography align="center">
            Cargando archivos adjuntos <CircularProgress size={20} />
         </Typography>
      );
   }
   if (
      called &&
      data !== undefined &&
      data !== null &&
      data.listarAdjuntos !== undefined &&
      data.listarAdjuntos.length > 0
   ) {
      return (
         <ListaArchivos
            archivos={data.listarAdjuntos}
            modo="bajar"
            metadata={metadata}
            onClickArchivo={onClickArchivo}
         />
      );
   }
   return <Typography>No existen archivos adjuntos para mostrar.</Typography>;
}

export default ListaArchivosGql;
